/* ErgoLab MY: show prices in SGD (whole dollars) to Singapore shoppers (20 Oct 2026).
   Checkout still charges MYR (no Shopify Payments in MY), so the cart drawer shows a note.
   Turns on when EITHER the visitor is in the Singapore market (country selector / ?country=SG)
   OR Shopify geolocates them in Singapore. Malaysian visitors see no change. */
(function () {
  var CFG = window.SG_HINT || {};
  var FALLBACK_RATE = CFG.fallbackRate || 0.31;            // SGD per 1 MYR, used only if live rates fail
  var NOTE = "You'll be charged in RM (Malaysian Ringgit) at checkout.";
  var rate = null, queued = false;

  function sessGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function isSG() {
    if ((CFG.marketCountry || '').toUpperCase() === 'SG') return Promise.resolve(true);
    if (/[?&]sg_hint=1\b/.test(location.search)) return Promise.resolve(true);
    var c = sessGet('sgHintGeo');
    if (c) return Promise.resolve(c === 'SG');
    return fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var g = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
        g = String(g).toUpperCase(); sessSet('sgHintGeo', g || 'XX'); return g === 'SG';
      })
      .catch(function () { return false; });
  }

  function getRate() {
    var c = parseFloat(sessGet('sgHintRate'));
    if (c > 0) return Promise.resolve(c);
    return new Promise(function (res) {
      var s = document.createElement('script');
      s.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
      s.onload = function () {
        try {
          var R = window.Currency && window.Currency.rates;
          var v = R && R.MYR && R.SGD ? R.MYR / R.SGD : 0;    // rates are "USD per 1 unit"
          if (v > 0.1 && v < 1) { sessSet('sgHintRate', String(v)); return res(v); }
        } catch (e) {}
        res(FALLBACK_RATE);
      };
      s.onerror = function () { res(FALLBACK_RATE); };
      document.head.appendChild(s);
    });
  }

  // "RM209", "RM 1,196", "RM209.00", "-RM100"
  var PRICE_G = /RM\s?(\d[\d,]*(?:\.\d{1,2})?)/g;
  function toSGD(rm) { var n = Math.round(parseFloat(String(rm).replace(/,/g, '')) * rate); return 'S$' + n.toLocaleString('en-SG'); }
  function conv(str) { return str.replace(PRICE_G, function (_, num) { return toSGD(num); }); }
  function skip(el) {
    for (var e = el; e && e !== document.body && e.nodeType === 1; e = e.parentElement) {
      var t = e.tagName;
      if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' || t === 'TEXTAREA' || t === 'INPUT' || t === 'SELECT' || t === 'OPTION' || t === 'TITLE') return true;
      if (e.classList && e.classList.contains('sg-note')) return true;
      if (e.hasAttribute && e.hasAttribute('data-sg-skip')) return true;
    }
    return false;
  }

  // ---- Singapore wording (Singapore shoppers only) ----
  // Order matters: longer phrases first. Shipping to SG is not free, so "free shipping" lines are reworded.
  var SWAPS = [
    // shipping: to Singapore it is not free
    [/Free Shipping\s*(?:Anywhere in|Across|Throughout) Malaysia/g, 'Fast Shipping to Singapore'],
    [/free shipping\s*(?:anywhere in|across|throughout) Malaysia/gi, 'fast shipping to Singapore'],
    [/free delivery (?:across Malaysia|nationwide)/gi, 'fast delivery to Singapore'],
    [/Free (?:&|and) Fast Shipping/gi, 'Fast Shipping'],
    [/\bFree Shipping\b/g, 'Fast Shipping'],
    [/\bfree shipping\b/g, 'fast shipping'],
    [/\bFREE SHIPPING\b/g, 'FAST SHIPPING'],
    // social proof earned in Malaysia: drop the country instead of claiming Singapore
    [/Malaysia['’]s Most[- ]Loved/gi, 'Most-Loved'],
    [/(Real|Other|Happy|Verified) Malaysian (Customers|Buyers|Sleepers|Families)/gi, '$1 $2'],
    [/Other Malaysians/gi, 'Other Customers'],
    [/Why Are Malaysians/gi, 'Why Are People'],
    [/Selling Out In Malaysia/gi, 'Selling Out Fast'],
    [/(?:sleep )?experts in Malaysia/gi, 'sleep experts'],
    [/(?:thousands of|over [\d,]+\+?) Malaysians/gi, function (m) { return m.replace(/Malaysians/i, 'customers'); }],
    // everything else: Malaysia -> Singapore
    [/\bMalaysia['’]s\b/g, function (m) { return 'Singapore' + m.slice(8); }],
    [/\bMalaysians\b/g, 'Singaporeans'],
    [/\bMalaysian\b/g, 'Singapore'],
    [/\bMALAYSIA\b/g, 'SINGAPORE'],
    [/\bMalaysia\b/g, 'Singapore']
  ];
  // Never reworded (masked first, so the rest of the sentence still converts):
  // facts about the Malaysian business, the cart note, the brand line.
  var KEEP = /Malaysian Ringgit|Malaysian warehouse|Malaysia and Thailand|Thailand and Malaysia|Sdn\.? Bhd\.?|ErgoLab Malaysia/gi;
  function inReview(el) {
    for (var e = el; e && e.nodeType === 1; e = e.parentElement) {
      var c = typeof e.className === 'string' ? e.className : '';
      if (/review|rvw|testimonial|jdgm|loox|okendo|yotpo|stamped/i.test(c)) return true;
      if (e.tagName === 'BLOCKQUOTE' || e.tagName === 'HEADER' && /country|locali[sz]ation/i.test(c)) return true;
      if (/localization|country-selector|disclosure__list|country/i.test(c) && e.querySelector && e.querySelector('select, [name="country_code"], .disclosure__item')) return true;
    }
    return false;
  }
  function reword(root) {
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), t, list = [];
    while ((t = tw.nextNode())) { if (/malaysia|free shipping|free delivery|free (?:&|and) fast/i.test(t.nodeValue) && !skip(t.parentElement) && !inReview(t.parentElement)) list.push(t); }
    list.forEach(function (node) {
      var kept = [];
      var v = node.nodeValue.replace(KEEP, function (m) { kept.push(m); return '\u0001' + (kept.length - 1) + '\u0002'; });
      SWAPS.forEach(function (sw) { v = v.replace(sw[0], sw[1]); });
      v = v.replace(/\u0001(\d+)\u0002/g, function (_, k) { return kept[+k]; });
      if (v !== node.nodeValue) node.nodeValue = v;
    });
  }

  function scan(root) {
    reword(root);
    // 1) prices split across tags, e.g. "RM<span>209</span>" or "<span>RM</span>209"
    root.querySelectorAll('*').forEach(function (el) {
      if (!el.children.length || skip(el)) return;
      var txt = el.textContent.replace(/\s+/g, ' ').trim();
      if (!/^-?RM\s?\d[\d,]*(\.\d{1,2})?$/.test(txt)) return;
      if (Array.prototype.some.call(el.children, function (c) { return /RM\s?\d/.test(c.textContent); })) return;   // handled deeper
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, nodes = [];
      while ((n = w.nextNode())) nodes.push(n);
      if (!nodes.length) return;
      nodes[0].nodeValue = (txt.charAt(0) === '-' ? '-' : '') + toSGD(txt.replace(/^-?RM\s?/, ''));
      for (var i = 1; i < nodes.length; i++) nodes[i].nodeValue = '';
    });
    // 2) prices inside a single text node, e.g. "You save RM100", "Checkout • RM398"
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), t, list = [];
    while ((t = tw.nextNode())) { if (/RM\s?\d/.test(t.nodeValue) && !skip(t.parentElement)) list.push(t); }
    list.forEach(function (node) { var v = conv(node.nodeValue); if (v !== node.nodeValue) node.nodeValue = v; });
    // 2b) seat page price box: "You save" = rounded was-price minus rounded price, so the S$ maths adds up
    document.querySelectorAll('.smx-save').forEach(function (sv) {
      var box = sv.closest('.x-price_part') || document;
      var cut = box.querySelector('.smx-cut'), off = box.querySelector('.smx-offer');
      var c = cut && parseFloat((cut.textContent.match(/S\$([\d,]+)/) || [])[1] ? cut.textContent.match(/S\$([\d,]+)/)[1].replace(/,/g, '') : NaN);
      var o = off && parseFloat((off.textContent.match(/S\$([\d,]+)/) || [])[1] ? off.textContent.match(/S\$([\d,]+)/)[1].replace(/,/g, '') : NaN);
      if (c > 0 && o > 0) { var want = 'S$' + (c - o).toLocaleString('en-SG'); if (sv.textContent !== want) sv.textContent = want; }
    });
    // 3) one-time note above the cart drawer checkout button (Singapore shoppers only)
    root.querySelectorAll('[class*="checkout" i] a, [class*="checkout" i] button, [id^="upCart"] button, [id^="upCart"] a, [class*="upcart"] button, [class*="upcart"] a').forEach(function (b) {
      if (!/check\s?out/i.test(b.textContent)) return;
      var p = b.parentElement; if (!p || p.querySelector(':scope > .sg-note')) return;
      var d = document.createElement('div'); d.className = 'sg-note'; d.textContent = NOTE; p.insertBefore(d, b);
    });
  }

  var watched = [];
  var CSS = '.sg-note{font-size:12px;line-height:1.4;color:#555;text-align:center;margin:0 0 8px;padding:0 6px}';
  function shadowRoots() {
    var out = [];
    document.querySelectorAll('#upCart, [id^="upCart"], shop-cart-sync').forEach(function (h) { if (h.shadowRoot) out.push(h.shadowRoot); });
    return out;
  }
  function watch(r) {
    if (watched.indexOf(r) > -1) return; watched.push(r);
    if (r !== document.body) { var st = document.createElement('style'); st.textContent = CSS; r.appendChild(st); }
    new MutationObserver(schedule).observe(r, { childList: true, subtree: true, characterData: true });
  }
  function schedule() {
    if (queued) return; queued = true;
    setTimeout(function () {
      queued = false;
      [document.body].concat(shadowRoots()).forEach(function (r) { try { watch(r); scan(r); } catch (e) {} });
    }, 30);
  }

  isSG().then(function (yes) {
    if (!yes) return;
    return getRate().then(function (r) {
      rate = r;
      document.documentElement.classList.add('sg-prices');
      var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
      schedule();
      setInterval(schedule, 1500);   // catches the cart drawer being created / re-rendered later
    });
  });
})();
